<template>
    <div>
        <div
            class="mypage_mainwindow"
            :class="{ 'mypage_reserve_list_window': reserve_list_flg, 'mypage_member_info_window': member_info_flg }">
            <div class="pageTitles">
                <div :class="iconclass"></div>
                <div>{{ page_title }}</div>
                <button @click="openHelpPage" class="help-btn" v-if="helpShow">ヘルプ</button>
            </div>
            <div class="cardwindow">
                <MypageHeader
                    :member_no="member_no"
                    :full_name="full_name"
                />
                <div class="graywindow">
                    <div class="mt-3 row row-notMx">
                        <!-- ここにコンテンツが表示される -->
                        <slot></slot>
                    </div>
                    <slot name="listBackBtn"></slot>
                </div>
            </div>
        </div>
        <MypageFooter
            @out-click="logOutBtn"
        />
    </div>
</template>

<script>
import MypageFooter from '../mypage/MypageFooter';
import MypageHeader from '../mypage/MypageHeader';
import { MEMBER_LOG_OUT } from "../../constants/signout";

export default {
    components: {
        MypageFooter,
        MypageHeader
    },
    props: {
        page_title: {
            type: String,
            required: true,
        },
        iconclass: {
            type: String,
            required: true
        },
        // 予約状況照会一覧の場合はtrueを受け取ってウィンドウの横幅を広げる。
        reserve_list_flg: {
            type: Boolean,
            required: false
        },
        // 会員情報参照画面の場合はtrueを受け取ってウィンドウの横幅を縮める。
        member_info_flg: {
            type: Boolean,
            required: false
        }
    },
    data () {
        return {
            helpShow: process.env.MIX_STYLE_NAME == 'hcgc' ? false: true,
            member_no: null,
            full_name: null
        };
    },
    created () {
        this.initialize();
    },
    methods: {
        initialize () {
            this.member_no = this.$store.state.auth.loginMember.member_no;
            this.full_name = this.$store.state.auth.loginMember.family_name + ' ' + this.$store.state.auth.loginMember.given_name;
        },
        logOutBtn () {
            this.$store.commit("loading/setIsLoading", true);
            this.$store.commit("mypage/useGolfCode", null);
            this.$apollo.query({
                query: MEMBER_LOG_OUT,
                variables: {}
            }).then(res => {
                localStorage.removeItem('web-token');
                this.$router.push('/');
            }).catch(error => {
                this.$store.commit("loading/setIsLoading", false);
            });
        },
        openHelpPage() {
            window.open('/help', '_blank');
        }
    }
}
</script>

<style scoped>
.mypage_reserve_list_window{
    width: 95%;
    max-width: 1100px;
    min-width: 800px;
}
.mypage_member_info_window{
    width: 35%;
    max-width: 850px;
    min-width: 700px;
}
@media screen and (max-width: 896px) {
    .mypage_member_info_window{
        width: 95%;
        max-width: initial;
        min-width: initial;
    }
    .mypage_reserve_list_window {
        width: 92%;
        max-width: initial;
        min-width: initial;
    }
}
</style>
